import Swiper from 'swiper';
import { Pagination, Navigation, Grid, Autoplay } from 'swiper/modules';

export default () => {
  // Profile Spotlights carousel
  document.querySelectorAll('.js-profileSwiper').forEach((el) => {
    new Swiper(el, {
      modules: [Pagination, Navigation],
      slidesPerView: 'auto',
      spaceBetween: 16,
      pagination: {
        el: el.querySelector('.swiper_buttons_pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },
      navigation: {
        nextEl: el.querySelector('.swiper_buttons_next'),
        prevEl: el.querySelector('.swiper_buttons_prev'),
      },
    });
  });

  // News / Events block carousels
  document.querySelectorAll('.js-newsEventsSwiper').forEach((el) => {
    const isSideBySide = el.dataset.layout === 'side-by-side';
    const hasAutoplay = el.dataset.autoplay === '1';
    const totalSlides = el.querySelectorAll('.swiper-slide').length;

    const getDynamic = (w) => {
      const perPage = w >= 1024 ? 4 : w >= 768 ? 2 : 1;
      const pages = Math.ceil(totalSlides / perPage);
      return pages > 4;
    };

    const config = {
      modules: [Pagination, Navigation, Grid, Autoplay],
      slidesPerView: 1,
      spaceBetween: 24,
      autoHeight: true,
      grid: { rows: 1, fill: 'row' },
      ...(hasAutoplay && {
        autoplay: { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true },
      }),
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 24, grid: { rows: 1, fill: 'row' } },
        1024: isSideBySide
          ? { slidesPerView: 1, spaceBetween: 30, grid: { rows: 4, fill: 'row' }, autoHeight: false }
          : { slidesPerView: 2, spaceBetween: 30, grid: { rows: 2, fill: 'row' }, autoHeight: false },
      },
      navigation: {
        nextEl: el.querySelector('.swiper_buttons_next'),
        prevEl: el.querySelector('.swiper_buttons_prev'),
      },
    };

    const init = (dynamic) => {
      return new Swiper(el, {
        ...config,
        pagination: {
          el: el.querySelector('.swiper_buttons_pagination'),
          clickable: true,
          dynamicBullets: dynamic,
          dynamicMainBullets: 4,
        },
      });
    };

    let dynamic = getDynamic(window.innerWidth);
    let swiper = init(dynamic);

    window.addEventListener('resize', () => {
      const next = getDynamic(window.innerWidth);
      if (next !== dynamic) {
        dynamic = next;
        swiper.destroy(true, true);
        swiper = init(dynamic);
      }
    });
  });
}
